import React from 'react';
import Collapsible from '../../../components/Collapsible';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/life-at-kingston/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="clubs-and-teams">
    <h1>學會／小組</h1>
    <p>
      作為一所小型學校，京斯敦提供一系列學會及校隊讓學生參加。這些學會是學校的驕傲，亦是組成學校的重要元素。學會非常多元化，職責亦有所不同，包括：表演、代表學校比賽、美化校內環境、幫助其他學校。
    </p>

    <Collapsible trigger="京斯敦環境保護小組">
      <p>環保小組負責推動綠色校園，減少生態足跡。</p>
    </Collapsible>
    <Collapsible trigger="學生會">
      <p>由學生以民主方式投票選出的學生會會通過舉辦不同活動向學校表達學生的意見。</p>
    </Collapsible>
    <Collapsible trigger="世界公民小組">
      <p>世界公民小組負責舉辦籌款活動，幫助柬埔寨一所名為Jong Ra的貧困學校。</p>
    </Collapsible>
    <Collapsible trigger="京斯敦合唱團及管弦樂團">
      <p>
        除了恆常的音樂課外，高年級學生亦有機會參加京斯敦合唱團及管弦樂團。合唱團現時由五十二名喜愛唱歌的學生組成，每學年為京斯敦大家庭表演四次。管選樂團規模較小，團員都非常熱愛拉奏弦樂器，並會在音樂老師的帶領下定期在不同的校內活動中表演或伴奏。
      </p>
    </Collapsible>
    <Collapsible trigger="校報">
      <p>學生小記者及編輯每年出版四期京斯敦學生校報。</p>
    </Collapsible>
    <Collapsible trigger="英語閱讀問答隊">
      <p>京斯敦的英語閱讀問答隊是香港其中一隊競爭隊伍，過往曾多次晉身總決賽，更於二零一二年取得全港冠軍。</p>
    </Collapsible>
    <Collapsible trigger="陸上曲棍球">
      <p>
        陸上曲棍球一直是京斯敦最受歡迎的活動，高低年級共有超過七十位學生參加曲棍球隊，每星期進行恆常練習，當中部份同學更每年代表學校爭奪九龍塘盃。
      </p>
    </Collapsible>
    <Collapsible trigger="籃球隊">
      <p>本校籃球隊由體育老師帶領。</p>
    </Collapsible>
    <Collapsible trigger="足球隊">
      <p>本校足球隊由巴西足球學院教授，低年級及高年級均設有足球隊，每年會與校外隊伍進行友誼賽。</p>
    </Collapsible>
  </ContentLayout>
);
